import { durationInvalidCheck, labelInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import dayjs from 'dayjs'
import React from 'react'
import clsx from 'clsx'

interface RecordingCardDetailsProps {
    label?: string | null
    duration?: string | null
    releaseDate?: string | null
}

const RecordingCardDetails = (props: RecordingCardDetailsProps) => {
    const { label, duration, releaseDate } = props
    return (
        <div className="details-container">
            <p className="small-2">
                <span className={clsx(labelInvalidCheck(label) && 'red-text bold')}>Label:&nbsp;</span>
                <strong>{label ? stringEscapeNewlines(label) : ''}</strong>
            </p>
            <p className="small-2">
                <span className={clsx(durationInvalidCheck(duration) && 'red-text bold')}>Duration:&nbsp;</span>
                <strong>{duration || ''}</strong>
            </p>
            <p className="small-2">
                <span>Release date:&nbsp;</span>
                <strong>{releaseDate ? dayjs(releaseDate).format('MMMM DD YYYY') : ''}</strong>
            </p>
        </div>
    )
}
export default RecordingCardDetails
